import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ObjectType } from '@vendasta/auxiliary-data-components';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import {
  Filter2TableModule,
  TABLE_DEFINITION,
  VaFilteredMatTableService,
  VaTableSortService,
} from '@vendasta/va-filter2-table';
import { BehaviorSubject } from 'rxjs';
import { AuxiliaryDataPageComponent } from './auxiliary-data-page.component';
import { AuxiliaryDataPanelComponentModule } from './auxiliary-data-panel/auxiliary-data-panel.component';
import { AuxiliaryDataTableFilterService, tableDefinitionFactory } from './auxiliary-data-table.model';
import { AuxiliaryDataTableService } from './auxiliary-data-table.service';
import { ButtonsColumnComponentModule } from './columns/buttons-column.component';
import { FieldSelectedForEditService } from './columns/field-selected-for-edit.service';
import { CurrencyChoiceComponentModule } from './field-editor/currency-choice.component';
import { FieldEditorComponentModule } from './field-editor/field-editor.component';
import { SELECTED_OBJECT_TYPE$$, VIEWING_ARCHIVED$$ } from './tokens';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { AuxDrawerComponent, SidepanelComponent } from './side-panel';
import en from '../../assets/en_devel.json';
import { LexiconModule } from '@galaxy/lexicon';

const _SELECTED_OBJECT_TYPE$$ = new BehaviorSubject<ObjectType>('business');

const _VIEWING_ARCHIVED$$ = new BehaviorSubject<boolean>(false);

@NgModule({
  declarations: [AuxiliaryDataPageComponent],
  imports: [
    CommonModule,
    CurrencyChoiceComponentModule,
    FieldEditorComponentModule,
    Filter2TableModule,
    GalaxyBadgeModule,
    GalaxyPageModule,
    GalaxyWrapModule,
    MatButtonModule,
    GalaxyEmptyStateModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TranslateModule,
    GalaxyAlertModule,
    ButtonsColumnComponentModule,
    AuxiliaryDataPanelComponentModule,
    SidepanelComponent,
    LexiconModule.forChild({
      componentName: 'common/auxiliary-data',
      baseTranslation: en,
    }),

    AuxDrawerComponent,
  ],
  providers: [
    VaFilteredMatTableService,
    VaTableSortService,
    AuxiliaryDataTableFilterService,
    {
      provide: TABLE_DEFINITION,
      useFactory: tableDefinitionFactory,
      deps: [AuxiliaryDataTableFilterService],
    },
    AuxiliaryDataTableService,
    FieldSelectedForEditService,
    {
      provide: SELECTED_OBJECT_TYPE$$,
      useValue: _SELECTED_OBJECT_TYPE$$,
    },
    {
      provide: VIEWING_ARCHIVED$$,
      useValue: _VIEWING_ARCHIVED$$,
    },
  ],
  exports: [AuxiliaryDataPageComponent],
})
export class AuxiliaryDataPageModule {}
